<script setup>
import { computed } from 'vue'

import DataSource from 'devextreme/data/data_source'
import ArrayStore from 'devextreme/data/array_store'

import { useWebSiteStore } from '@/stores/web-site.store'
import { useFocusRestore } from '@/composables/focus-restore'

import { DxTextBox } from 'devextreme-vue/text-box'

import GridDropDownBox from '@/components/shared/GridDropDownBox.vue'

const props = defineProps({
  data: {
    type: Object,
    default: null,
  },
  value: {
    type: Number,
    default: null,
  },
  valueText: {
    type: String,
    default: null,
  },
  country: {
    type: Number,
    default: null,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
})

const webSiteStore = useWebSiteStore()

const defaultDataSource = new DataSource({
  store: new ArrayStore({
    data: webSiteStore.states,
    key: 'id',
  }),
  searchExpr: ['code', 'name'],
})

const hasStructuredLocationData = computed(() => props.country && !!webSiteStore.countries.find(c => c.id === props.country)?.has_structured_location_data)

const computedDataSource = computed(() => {
  const ds = defaultDataSource
  if (props.country) {
    ds.filter(['country', '=', props.country])
  }

  return ds
})

const emit = defineEmits({
  valueChanged: (e) => true,
})

const { rootRef, onFocusIn, onFocusOut } = useFocusRestore('state', { trackInnerFocus: true })
</script>

<template>
  <div
    ref="rootRef"
    @focusin="onFocusIn"
    @focusout="onFocusOut"
  >
    <grid-drop-down-box
      v-if="hasStructuredLocationData"
      :value="props.value"
      :data-source="computedDataSource"
      :remote-operations="false"
      :disabled="props.disabled"
      :columns="[
        { dataField: 'code', caption: $t('common.code') },
        { dataField: 'name', caption: $t('common.name'), sortOrder: 'asc' },
      ]"
      @value-changed="(e) => {
        emit('valueChanged', { value: e })
        props.data?.setValue(e)
      }"
    />
    <dx-text-box
      v-else
      :value="props.valueText"
      :disabled="props.disabled"
      @value-changed="(e) => {
        emit('valueChanged', { value: e.value })
        props.data?.setValue(e.value)
      }"
    />
  </div>
</template>
